import { useNetworkMetadata } from "Flocknote/apiHooks";

export default function useEmailOnly() {
  const [data] = useNetworkMetadata();
  const countryCode = data?.address?.countryCode;

  const emailOnly = isInternational(countryCode);
  return { emailOnly };
}

export function useIsInternational() {
  const [data] = useNetworkMetadata();
  const countryCode = data?.address?.countryCode;

  return isInternational(countryCode);
}

function isInternational(countryCode = "US") {
  let lowerCode = countryCode?.toLowerCase();
  return lowerCode !== "us" && lowerCode !== "ca";
}
